import { useCallback } from "react";

export default function useSubsectionCrud({ subjectId, saveSubject, loadSubject }) {
  const refresh = useCallback(async () => {
    return await loadSubject({ force: true });
  }, [loadSubject]);

  const saveOne = useCallback(
    async ({ key, payloadObject, syncFromFreshSubject }) => {
      await saveSubject({
        input: {
          subjects: { id: Number(subjectId) },
          [key]: [payloadObject],
        },
      });

      const fresh = await refresh();
      syncFromFreshSubject?.(fresh);
      return fresh;
    },
    [saveSubject, subjectId, refresh]
  );

  const deleteOne = useCallback(
    async ({ key, id, syncFromFreshSubject }) => {
      await saveSubject({
        input: { subjects: { id: Number(subjectId) } },
        input_delete: [{ id: Number(id), key }],
      });

      const fresh = await refresh();
      syncFromFreshSubject?.(fresh);
      return fresh;
    },
    [saveSubject, subjectId, refresh]
  );

  return { saveOne, deleteOne, refresh };
}